import {getField, updateField} from 'vuex-map-fields';
import BatchRunWeek from '@/commonFunction/baseTableModule'

let batch_run_week = new BatchRunWeek('/ws/table/batch_run_week/');

const state = {
    ...batch_run_week.state,
    active_batch_run: null,
    smd_start_plan: null,
    smd_end_plan: null,
    tht_start_plan: null,
    tht_end_plan: null,
    smd_end: null,
    tht_end: null,
    lt_mat: null,
    lt_min: null,
    columns: [
        {text: 'Monday', value: 'wd1', sortable: false, divider: false, brief: true,},
        {text: 'Tuesday', value: 'wd2', sortable: true, divider: false, brief: true,},
        {text: 'Wednesday', value: 'wd3', sortable: false, divider: false, brief: true,},
        {text: 'Thursday', value: 'wd4', sortable: false, divider: false, brief: true,},
        {text: 'Friday', value: 'wd5', sortable: false, divider: false, brief: true,},
        {text: 'indicators', value: 'indicator', sortable: false, divider: false, brief: true,},
    ],
};
const getters = {
    ...batch_run_week.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...batch_run_week.actions,
};
const mutations = {
    ...batch_run_week.mutations,
};

export default {
    modules: {
        BatchRunWeek: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}

// const baseUrl = '/api/quote/'
// const wsURL = '/ws/table/customer/'